export default __webpack_public_path__ + "static/media/professionalDetailshelp@2x.fed0a964.png";